import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIResult } from '../interfaces/api-result';

export function apiResult<T>(): OperatorFunction<APIResult<T>, T> {
  return map((result: APIResult<T>) => {
    if (result.succeeded) {
      return result.result ?? <T>{};
    } else {
      throw new Error(result.errors?.join(', '));
    }
  });
}
